<template>
  <div class="list-operation-form" id="searchBox">
    <div
      v-if="formModel[formOptions.statusOption.prop]"
      class="status-image"
      :style="{
        backgroundImage:
          'url(' +
          (formOptions.statusOption &&
            formOptions.statusOption.statusImg[
              formModel[formOptions.statusOption.prop]
            ]) +
          ')'
      }"
    ></div>
    <el-form
      :model="formModel"
      :ref="tempFromName"
      class="demo-formData"
      label-position="right"
      :inline="true"
    >
      <el-row class="complex-box">
        <template v-for="(column, index) in formOptions.columns">
          <el-col
            v-if="column.hidden == true ? false : true"
            :key="index"
            :span="column.isAllline ? 24 : column.span || 6"
            :style="column.style"
          >
            <div v-if="column.type == 'title'" class="column-title">
              {{ column.label }}
            </div>
            <el-row v-else>
              <el-col :span="column.isAllline ? column.span || 6 : 24">
                <el-form-item
                  :label="column.label"
                  :prop="column.prop"
                  :label-width="
                    formOptions.labelWidth || column.labelWidth || '100px'
                  "
                >
                  <!--输入框-->
                  <el-input
                    v-if="column.type === columnType.input || !column.type"
                    v-model.trim="formModel[column.prop]"
                    clearable
                    :disabled="column.disabled || formOptions.disabled"
                    :maxLength="column.maxLength"
                    class="input-self-style"
                  ></el-input>

                  <!--数字输入框-->
                  <el-input-number
                    autocomplete="off"
                    clearable
                    v-else-if="column.type === columnType.inputNumber"
                    v-model.trim="formModel[column.prop]"
                    @change="inputChange(column)"
                    :precision="column.precision || 1"
                    :min="column.min || 0"
                    :max="column.max || 10000"
                    :disabled="column.disabled || formOptions.disabled"
                    class="input-self-style"
                    name="input"
                    @keydown.enter.native="keyDownEnter($event)"
                    @focus="selectContent($event)"
                  ></el-input-number>
                  <!--下拉框-->
                  <el-select
                    v-else-if="column.type === columnType.select"
                    v-model="formModel[column.prop]"
                    placeholder="请选择"
                    @change="selectChange(column)"
                    :multiple="column.multiple || false"
                    :collapse-tags="column.collapse || false"
                    filterable
                    :disabled="column.disabled || formOptions.disabled"
                    class="input-self-style"
                  >
                    <el-checkbox
                      v-if="column.isSelectAll"
                      class="store-checkbox"
                      v-model="column.checked"
                      @change="selectAll(column)"
                      :disabled="column.isEdit"
                      >全选</el-checkbox
                    >
                    <el-option
                      v-for="item in column.data"
                      :key="item[column.uniqueKey] || item.value || item.id"
                      :label="item[column.labelKey] || item.label || item.name"
                      :title="item[column.labelKey] || item.label || item.name"
                      :value="item[column.uniqueKey] || item.value || item.id"
                    ></el-option>
                  </el-select>

                  <!--单选按钮-->
                  <el-radio-group
                    v-else-if="column.type === columnType.radio"
                    v-model="formModel[column.prop]"
                    :disabled="column.disabled || formOptions.disabled"
                    @change="radioChange(column)"
                  >
                    <el-radio
                      v-for="item in column.data"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-radio>
                  </el-radio-group>
                  <!--多选按钮-->
                  <el-checkbox-group
                    v-else-if="column.type === columnType.checkbox"
                    v-model="formModel[column.prop]"
                    :disabled="column.disabled || formOptions.disabled"
                    @change="checkBoxChange(column)"
                  >
                    <el-checkbox
                      v-for="item in column.data"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-checkbox>
                  </el-checkbox-group>

                  <!--级联选择器-->
                  <el-cascader
                    v-else-if="column.type === columnType.cascader"
                    v-model="formModel[column.prop]"
                    :options="column.data"
                    @change="column.change"
                    :props="column.props"
                    :show-all-levels="column.showAllLevels"
                  ></el-cascader>

                  <!--时间选择器 可配置间隔-->
                  <el-time-select
                    v-else-if="column.type === columnType.timeSelect"
                    v-model="formModel[column.prop]"
                    :picker-options="{
                      start: '08:30',
                      step: '00:15',
                      end: '18:30'
                    }"
                    placeholder="选择时间"
                  ></el-time-select>

                  <!--日期选择器-->
                  <el-date-picker
                    v-else-if="column.type === columnType.datePicker"
                    :format="column.format || 'yyyy-MM-dd'"
                    :value-format="column.format || 'yyyy-MM-dd'"
                    v-model="formModel[column.prop]"
                    :type="column.dateType || 'date'"
                    placeholder="选择日期"
                  ></el-date-picker>

                  <!--日期时间选择器-->
                  <el-date-picker
                    v-else-if="column.type === columnType.dateTimePicker"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="formModel[column.prop]"
                    placeholder="选择日期时间"
                    :default-time="column.defaultTime || '00:00:00'"
                    @change="selectChange(column)"
                    :disabled="column.disabled || formOptions.disabled"
                    class="input-self-style"
                  ></el-date-picker>
                  <date-time-range
                    :ref="column.prop"
                    v-else-if="column.type === columnType.datetimeRange"
                    :column="column"
                  ></date-time-range>
                  <date-time-range-button
                    :ref="column.prop"
                    v-else-if="column.type === columnType.dateTimeRangeButton"
                    :column="column"
                  ></date-time-range-button>

                  <date-time-range-search
                    :ref="column.prop"
                    v-else-if="column.type === columnType.dateTimeRangeSearch"
                    :column="column"
                  ></date-time-range-search>
                  <store-input-dialog
                    :column="column"
                    :defaultValue="formModel[column.prop]"
                    class="input-self-style"
                    @valueChange="itemValueChange"
                    v-else-if="column.type === columnType.storeInputDialog"
                  ></store-input-dialog>
                  <supplier-input-dialog
                    ref="supplierInputDialog"
                    :column="column"
                    :defaultValue="formModel[column.prop]"
                    class="input-self-style"
                    @valueChange="itemValueChange"
                    v-else-if="column.type === columnType.supplierInputDialog"
                  ></supplier-input-dialog>
                  <warehouse-input-dialog
                    ref="warehouseInputDialog"
                    :column="column"
                    :defaultValue="formModel[column.prop]"
                    class="input-self-style"
                    @valueChange="itemValueChange"
                    v-else-if="column.type === columnType.warehouseInputDialog"
                  ></warehouse-input-dialog>
                  <warehouse-input-dialog-two
                    ref="warehouseInputDialogTwo"
                    :column="column"
                    :defaultValue="formModel[column.prop]"
                    class="input-self-style"
                    @valueChange="itemValueChange"
                    v-else-if="column.type === columnType.warehouseInputDialogTwo"
                  ></warehouse-input-dialog-two>
                  <inventory-order-input-dialog
                    ref="inventoryOrderInputDialog"
                    :column="column"
                    :defaultValue="formModel[column.prop]"
                    class="input-self-style"
                    @valueChange="itemValueChange"
                    v-else-if="column.type === columnType.inventoryOrderInputDialog"
                  ></inventory-order-input-dialog>
                  <wholesaleCustomer-input-dialog
                    ref="wholesaleCustomerInputDialog"
                    :column="column"
                    :defaultValue="formModel[column.prop]"
                    class="input-self-style"
                    @valueChange="itemValueChange"
                    v-else-if="column.type === columnType.wholesaleCustomerInputDialog"
                  ></wholesaleCustomer-input-dialog>
                  <order-dialog
                    ref="orderDialog"
                    :column="column"
                    :defaultValue="formModel[column.prop]"
                    class="input-self-style"
                    @valueChange="itemValueChange"
                    v-else-if="column.type === columnType.orderDialog"
                  ></order-dialog>
                  <span
                    v-if="column.tips"
                    style="color: orange; padding-left: 10px"
                  >{{ "！" + column.tips }}</span
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </template>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import dateTimeRange from "@/components/controls/dateTimeRange";
import dateTimeRangeButton from "@/components/controls/dateTimeRangeButton";
import dateTimeRangeSearch from "@/components/controls/dateTimeRangeSearch";
import storeInputDialog from "@/components/business/storeIdInputDialog";
import warehouseInputDialog from "@/components/business/warehouseInputDialog";
import warehouseInputDialogTwo from "@/components/business/warehouseInputDialogTwo";
import supplierInputDialog from "@/components/business/supplierInputDialog";
import inventoryOrderInputDialog from "@/components/business/inventoryOrderInputDialog";
import wholesaleCustomerInputDialog from "@/components/business/wholesaleCustomerInputDialog";
import orderDialog from "@/components/business/orderDialog";
import utils from "@/utils/index";
export default {
  components: {
    dateTimeRange,
    dateTimeRangeButton,
    dateTimeRangeSearch,
    storeInputDialog,
    warehouseInputDialog,
    supplierInputDialog,
    inventoryOrderInputDialog,
    wholesaleCustomerInputDialog,
    orderDialog,
    warehouseInputDialogTwo,
  },
  props: {
    formOptions: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      operateBtnIcon: {
        insert: "el-icon-plus",
        delete: "el-icon-close",
        update: "el-icon-update",
        release: "el-icon-s-promotion",
        audit: "el-icon-circle-check"
      },
      tempFromName: "form_" + new Date().getMilliseconds(),
      formModel: {}, // 提交对象
      formRule: {}, //验证规则
      columnType: utils.columnType
    };
  },
  created() {
    this.setOptionsData();
  },
  methods: {
    itemValueChange(value, column) {
      this.formModel[column.prop] = value;
      this.$emit("valueChange", value, column);
    },
    setFormModel(formModel) {
      let keys = Object.keys(formModel);
      keys.map(key => {
        this.$set(this.formModel, key, formModel[key]);
      });
      this.formOptions.columns.map(column => {
        if (column.type == this.columnType.radio) {
          this.setRadioValue(column);
        } else if (column.type == this.columnType.checkbox) {
          this.setCheckBoxValue(column);
        }
      });
    },
    inputChange(options) {
      options.change && options.change(this.formModel, options);
    },
    //enter实现tab切换
    keyDownEnter (event) {
      let inputs = document.getElementsByName('input');
      if (event.keyCode === 13) { // 回车
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i] === document.activeElement) {
            if (i === inputs.length) return;
            if (!inputs[i + 1]) return;
            if (inputs[i + 1].localName === 'input') {
              inputs[i + 1].focus();
              return;
            }
          }
        }
      }
    },
    selectContent(event) {
      event.currentTarget.select();
    },
    setOptionsData() {
      let optionsLength = this.formOptions.columns.length;
      for (let index = 0; index < optionsLength; index++) {
        optionsLength = this.formOptions.columns.length;
        let column = this.formOptions.columns[index];

        this.$set(
          this.formModel,
          column.prop,
          column.type == this.columnType.checkbox ||
            (column.type == "select" && column.multiple == true)
            ? []
            : ""
        );
        this.$set(this.formRule, column.prop, column.rule || []);
        // 获取下拉值
        if (
          column.url &&
          column.type === this.columnType.select &&
          (!column.data || column.data.length == 0)
        ) {
          column.data = [];
          this.getSelectData(column);
        }
        //设置默认值
        if (column.defaultValue != undefined) {
          this.formModel[column.prop] = column.defaultValue;
        }
        //设置单选按钮
        this.setRadioColumn(column, this.formOptions, index);
        //设置多选按钮
        this.setCheckboxColumn(column, this.formOptions, index);

        //设置默认选项
        if (
          column.defaultIndex != undefined &&
          column.type === this.columnType.select &&
          column.data.length > 0
        ) {
          this.formModel[column.prop] = item.data[column.defaultIndex].value;
        }
        // 联动数据回填
        if (
          column.type === this.columnType.select &&
          this.formModel[column.prop]
        ) {
          this.selectChange(column, true);
        }
      }
    },
    setRadioColumn(column, formOptions, index) {
      if (column.type === this.columnType.radio) {
        if (
          column.prop.indexOf("Radio") == -1 &&
          formOptions.columns.filter(item => item.prop == column.prop + "Radio")
            .length == 0
        ) {
          let cloneColumn = this.$utils.deepClone(column);
          cloneColumn.prop = cloneColumn.prop + "Radio";
          formOptions.columns.splice(index, 0, cloneColumn);
          column.hidden = true;
          column.type = "input";
          this.$set(this.formModel, cloneColumn.prop, "");
          if (column.url) {
            this.getSelectData(cloneColumn);
          } else {
            this.setRadioValue(cloneColumn);
          }
        } else {
          this.setRadioValue(column);
        }
      }
    },
    setCheckboxColumn(column, formOptions, index) {
      if (column.type === this.columnType.checkbox) {
        if (
          column.prop.indexOf("Checkbox") == -1 &&
          formOptions.columns.filter(
            item => item.prop == column.prop + "Checkbox"
          ).length == 0
        ) {
          let cloneColumn = this.$utils.deepClone(column);
          cloneColumn.prop = cloneColumn.prop + "Checkbox";
          formOptions.columns.splice(index - 1, 0, cloneColumn);
          column.type = "input";
          column.hidden = true;
          this.$set(this.formModel, cloneColumn.prop, []);
          if (column.url) {
            this.getSelectData(cloneColumn);
          } else {
            this.setCheckBoxValue(cloneColumn);
          }
        } else {
          this.setCheckBoxValue(column);
        }
      }
    },
    //给单选按钮组赋值
    //设置了value，需要给name赋值
    setRadioValue(column) {
      let radioValue = this.formModel[column.prop.replace("Radio", "")];
      if (radioValue !== undefined && radioValue !== null && column.data) {
        let checkData = column.data.filter(item => {
          return item.value == radioValue || item.id == radioValue;
        });
        if (checkData.length > 0)
          this.$set(
            this.formModel,
            column.prop,
            checkData[0].label || checkData[0].name
          );
      } else if (column.defaultValue) {
        let checkItem = column.data.filter(item => {
          return (
            item.value == column.defaultValue || item.id == column.defaultValue
          );
        });
        if (checkItem.length > 0)
          this.formModel[column.prop] = checkItem[0].label || checkItem[0].name;
      }
    },
    setCheckBoxValue(column) {
      let checkboxValue = this.formModel[column.prop.replace("Checkbox", "")];
      if (
        checkboxValue !== undefined &&
        checkboxValue !== null &&
        checkboxValue.length > 0 &&
        column.data
      ) {
        let checkboxValue1 = [];
        checkboxValue.map(item => {
          //纯数字类型
          if (item == parseInt(item)) {
            item = parseInt(item);
          }
          checkboxValue1.push(item);
        });
        let checkData = column.data
          .map(item => {
            return checkboxValue1.indexOf(item.value || item.id) > -1
              ? item.name || item.label
              : null;
          })
          .filter(Boolean);
        this.formModel[column.prop] = checkData;
      } else if (column.defaultValue) {
        let checkItem = column.data.filter(item => {
          return (
            item.value == column.defaultValue || item.id == column.defaultValue
          );
        });
        this.formModel[column.prop] = checkItem.map(item => {
          return item.label || item.name;
        });
      } else if (column.defaultIndex) {
        this.formModel[column.prop] = [];
        this.formModel[column.prop.replace("Checkbox", "")] = [];
        column.defaultIndex.map(index => {
          let checkItem = column.data[index];
          this.formModel[column.prop].push(checkItem.label || checkItem.name);
          this.formModel[column.prop.replace("Checkbox", "")].push(
            checkItem.id || checkItem.value
          );
        });
      }
    },
    // 获取各种下拉菜单信息
    getSelectData(column, param, url) {
      let params = Object.assign(column.param || {}, param || {});
      // 缓存读取
      column.data = this.$utils.getDataByKey(column.url);
      if (!column.data || column.data.length == 0) {
        this.$axios
          .fetchPost((column.url || url) + "/list", params || {})
          .then(data => {
            column.url = url || column.url;
            if (data.code == 200) {
              if (column.multiple && this.formModel[column.prop + "List"]) {
                let selectList = this.formModel[column.prop + "List"];
                data.data.map(item => {
                  let uniqueValue =
                    item[column.uniqueKey] || item.id || item.value;
                  let idx = selectList
                    .map(selItem => {
                      return (
                        selItem[column.uniqueKey] || selItem.id || selItem.value
                      );
                    })
                    .indexOf(uniqueValue);
                  if (idx > -1) {
                    selectList.splice(idx, 1);
                  }
                });
                this.$set(column, "data", [...data.data, ...selectList]);
              } else if (column.isHasAll || column.isHasAllShop) {
                // 下拉选择添加‘总部’‘全部门店’字段
                if (column.isHasAll) {
                  data.data.unshift({ name: "总部", id: -1 });
                }
                if (column.isHasAllShop) {
                  data.data.unshift({ name: "全部门店", id: null });
                }
                this.$set(column, "data", data.data);
              } else {
                this.$set(column, "data", data.data);
              }
              if (column.type === this.columnType.checkbox) {
                this.setCheckBoxValue(column);
              } else if (column.type === this.columnType.radio) {
                this.setRadioValue(column);
              } else if (column.defaultIndex != undefined) {
                this.formModel[column.prop] =
                  column.data[column.defaultIndex].value;
              }
              if (column.cache) {
                this.$utils.setDataByKey(column.url, column.data);
              }
              if (this.formModel[column.prop]) {
                this.selectChange(column, true);
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    radioChange(column) {
      let radioData = column.data.filter(
        item =>
          item.label == this.formModel[column.prop] ||
          item.name == this.formModel[column.prop]
      );
      if (radioData.length > 0) {
        this.formModel[column.prop.replace("Radio", "")] =
          radioData[0].value || radioData[0].id;
      }
      column.change && column.change(this.formModel);
    },
    checkBoxChange(column) {
      this.formModel[column.prop.replace("Checkbox", "")] = [];
      column.data.map(item => {
        this.formModel[column.prop].map(checkItem => {
          if (checkItem == item.name || checkItem == item.label) {
            this.formModel[column.prop.replace("Checkbox", "")].push(
              item.id || item.value
            );
          }
        });
      });
      column.change && column.change(this.formModel);
    },
    // 全选
    selectAll(column) {
      this.formModel[column.prop] = [];
      if (column.checked) {
        column.data.map(item => {
          this.formModel[column.prop].push(item.id);
        });
      } else {
        this.formModel[column.prop] = [];
      }
    },
    // 下拉框联动
    selectChange(column, isBackfill) {
      if (column.childProps) {
        // 根据当前选项获取子集
        // 联动字段选项赋值
        let childColumn = this.formOptions.columns.filter(item => {
          return item.prop === column.childProps;
        });
        if (!childColumn || !childColumn.length > 0) {
          return;
        }
        childColumn = childColumn[0];
        // 当前父类选择的数据
        let parentData = column.data.filter(dataItem => {
          return dataItem.value === this.formModel[column.prop];
        });
        // 错误数据兼容
        if (parentData.length > 0) {
          childColumn.data = parentData[0].children;
        }
      } else if (column.selectAssociated) {
        // 根据当前选项查询数据
        // 关联字段选项赋值
        let associatedcolumn = this.formOptions.columns.filter(item => {
          return item.prop === column.selectAssociated.prop;
        });
        if (!associatedcolumn || !associatedcolumn.length > 0) {
          return;
        }
        if (!isBackfill) {
          this.formModel[column.selectAssociated.prop] = "";
        }
        associatedcolumn = associatedcolumn[0];
        associatedcolumn.url = column.selectAssociated.url;
        let param = {};
        param[column.prop] = this.formModel[column.prop];
        this.getSelectData(associatedcolumn, param);
      }
      column.change && column.change(this.formModel);
    },
    // 获取组件数据
    getSpecialAttributes() {
      let rtn = true;
      this.formOptions.columns.map(item => {
        switch (item.type) {
          case this.columnType.datetimeRange:
          case this.columnType.dateTimeRangeButton:
            rtn = this.$refs[item.prop][0].getFormData();
            if (rtn) {
              this.formModel["st" + item.prop] = rtn.split(",")[0];
              this.formModel["ed" + item.prop] = rtn.split(",")[1];
            }
        }
      });
      return rtn;
    },
    // 获取数据
    getFormModel() {
      let rtn = this.getSpecialAttributes();
      if (rtn === false) return;
      let param = Object.assign({}, this.formModel);
      let searchParam = {};
      this.formOptions.columns.map(column => {
        if (
          param[column.prop] != "" &&
          param[column.prop] != undefined &&
          param[column.prop] != null
        ) {
          if (column.isFuzzy)
            searchParam[column.prop] = "%" + param[column.prop] + "%";
          else {
            searchParam[column.prop] = param[column.prop];
          }
        }
      });
      return searchParam;
    }
  }
};
</script>
<style scoped>
.list-operation-form {
  position: relative;
}
.list-operation-form .complex-box {
  padding: 6px;
  background-color: #f2f2f2;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 14px;
}
.list-operation-form .btn-box {
  text-align: center;
}
.list-operation-form .search-item {
  display: inline-block;
  margin-bottom: 5px;
}
.list-operation-form .status-image {
  position: absolute;
  top: 10px;
  right: 26%;
  width: 164px;
  height: 87px;
  background-size: 100% 100%;
  z-index: 1000;
}
>>> .el-select__tags .el-tag.el-tag--info {
  padding-right: 18px;
  max-width: unset;
}
>>> .el-tag.el-tag--info .el-tag__close {
  right: 1px;
}
.list-operation-form >>> .el-form-item {
  min-height: 40px;
}
.input-self-style {
  width: 250px;
}
.input-self-style >>> .el-input {
  width: 260px;
}
.store-checkbox {
  text-align: right;
  width: 100%;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/template/listOperationForm.vue